export function formatEmissionsLimit(value: number, unit: string): string {
  return `${value.toLocaleString(undefined, { maximumFractionDigits: 4 })} ${unit}`;
}
